import {
  PushMessageListReq,
  ResponseDTOBoolean,
  ResponseDTOPageQueryResultPushMessageListResp,
  ResponseDTOPushMessageDetailResp,
} from '@/types/noticeConfig';
import axiosInstance from './axiosInstance';
import type { AxiosResponse } from 'axios';
const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const postPushMessageRecordTest = async (params: {
  pushTitle: string;
  pushTitleJa: string;
  pushContent: string;
  pushContentJa: string;
  testUserId: number;
  jumpType?: number;
  artworkId?: string;
  bizId?: string;
  cover?: string;
  ratio?: number;
}): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/pushMessageRecord/test`,
    params
  );

  return response;
};
/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const postPushMessageRecordSaveOrUpdate = async (params: {
    file: File;
    id: number;
    pushTitle: string;
    pushTitleJa: string;
    pushContent: string;
    pushContentJa: string;
    pushTime: string;
    pushTargetType: number;
    pushStatus: number;
    jumpType?: number;
    artworkId?: string;
    bizId?: string;
    cover?: string;
    ratio?: number;
  },
  option
): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/pushMessageRecord/saveOrUpdate`,
    params,
    option
  );

  return response;
};

/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const postPushMessageRecordList = async (
  params: PushMessageListReq
): Promise<AxiosResponse<ResponseDTOPageQueryResultPushMessageListResp>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/pushMessageRecord/list`,
    params
  );

  return response;
};

/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const getPushMessageRecordDetail = async (params: {
  id: number;
}): Promise<AxiosResponse<ResponseDTOPushMessageDetailResp>> => {
  const response = await axiosInstance.get(
    `${baseUrl}/pushMessageRecord/detail`,
    { params }
  );

  return response;
};
